module.exports = __webpack_public_path__ + "media/images/samples/300x300/15-e041a3316ed2b187a86d527a17fb7bec.jpg";